import { Col as AntCol } from 'antd'
import type { ComponentProps } from 'react'

type AntColProps = ComponentProps<typeof AntCol>

export interface AppColProps extends AntColProps {}

export const AppCol = (props: AppColProps) => <AntCol {...props} />
